д<template>
  <w-flex class="justify-center grow">
      <w-card class="mt3 grow initiative">
        <template #title>
          <w-toolbar>
            <div class="title3">Форма создания инициативы</div>
          </w-toolbar>
        </template>
        <template v-if="!user.authorized">
          <div>
            Для продолжения вам потребуется авторизоваться.
          </div>
          <a v-bind:href="'https://account.misis.club/?return=' + url">
            <w-button class="mt3">Авторизоваться</w-button>
          </a>
        </template>

        <div v-else>
          <w-form class="mt2">
            <w-input
            class="mb5"
            v-model="title"
            label="Заголовок"
            color="black">
            </w-input>
            <w-textarea
            class="mb3"
            v-model="short"
            color="black">
            Короткое описание инициативы</w-textarea>
            <w-textarea
            class="mb3"
            v-model="long"
            autogrow
            rows="6"
            color="black"
            >Полный текст инициативы</w-textarea>
            <w-button v-on:click="send">Отправить</w-button>
          </w-form>
        </div>
      </w-card>
  </w-flex>
</template>

<script>
import {createInitiative} from '../components/util.js';

export default {
  name: 'NewInitiative',
  components: {
  },
  props: {
    user: Object
  },
  data: () => ({
      title: '',
      short: '',
      long: '',
      url: window.location.href
  }),
  methods: {
    send: async function(){
      if (!this.user.authorized) {
        this.$waveui.notify('Для создания инициативы нужно войти', 'info');
        return;
      }
      if (!this.title || !this.short || !this.long) {
        this.$waveui.notify('Пожалуйста, заполните все поля', 'info');
        return;
      }
      var success = await createInitiative(this.title, this.short, this.long);
      if (success) {
        this.$waveui.notify('Ваша инициатива успешно отправлена!', 'success');
        this.title = '';
        this.short = '';
        this.long = '';
      }
      else {this.$waveui.notify('Произошла непредвиденная ошибка.', 'error');}
    }
  }
}
</script>

<style>
@font-face {
  font-family: "Open Sans";
  src: local("Open Sans"),
   url(../fonts/OpenSans/OpenSans-Regular.ttf) format("truetype");
}

.w-app{
  font-family: "Open Sans";
}

.initiative {
  max-width: 1000px;
  min-width: 500px;
}

.break {
  flex-basis: 100%;
  height: 0;
}
</style>
